var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 44,
    viewBox: "0 0 28 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6477 0.802491C1.66514 0.354257 2.0284 0 2.47059 0H25.5294C25.9716 0 26.3349 0.354257 26.3523 0.802491L27.9994 43.1316C28.0082 43.3587 27.9254 43.5797 27.7702 43.7435C27.6149 43.9074 27.4005 44 27.1765 44H19.4902C19.0988 44 18.7616 43.7206 18.6833 43.3316L14 20.0515L9.3167 43.3316C9.23845 43.7206 8.90115 44 8.5098 44H0.82353C0.599482 44 0.385104 43.9074 0.229834 43.7435C0.0745633 43.5797 -0.00819554 43.3587 0.000641612 43.1316L1.6477 0.802491ZM3.26225 1.67089L3.19724 3.34177H24.8028L24.7377 1.67089H3.26225ZM24.8678 5.01266H21.9608V10.2464C22.0172 10.6113 22.25 11.1838 22.7978 11.629C23.2553 12.0007 23.9901 12.3296 25.1519 12.3134L24.8678 5.01266ZM25.2168 13.9832C23.7075 14.012 22.5751 13.5889 21.7681 12.9331C20.8309 12.1715 20.411 11.1581 20.3199 10.4056C20.3158 10.3718 20.3137 10.3378 20.3137 10.3038V5.01266H14.8235V11.9747C14.8235 12.4361 14.4548 12.8101 14 12.8101C13.5452 12.8101 13.1765 12.4361 13.1765 11.9747V5.01266H7.68627V10.3038C7.68627 10.3378 7.68422 10.3718 7.68013 10.4056C7.58904 11.1581 7.16912 12.1715 6.23188 12.9331C5.42486 13.5889 4.2925 14.012 2.78317 13.9832L1.68021 42.3291H7.83737L13.1931 15.7064C13.2714 15.3174 13.6087 15.038 14 15.038C14.3913 15.038 14.7286 15.3174 14.8069 15.7064L20.1626 42.3291H26.3198L25.2168 13.9832ZM2.84814 12.3134C4.00986 12.3296 4.74474 12.0007 5.20217 11.629C5.75002 11.1838 5.98277 10.6113 6.03922 10.2464V5.01266H3.13222L2.84814 12.3134Z",
    fill: "url(#paint0_linear_3687_2021)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3687_2021",
    x1: 3.61704e-7,
    y1: 48.7143,
    x2: 32.1212,
    y2: 44.1878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPants);
export default __webpack_public_path__ + "static/media/pants.5640713f3155fed23abbe07e8a930b6d.svg";
export { ForwardRef as ReactComponent };